//$Id$
/**
 * @file date-util
 * @version 1.0.0
 */
/**
 * This global object contains available date types.
 * @global
 * @type {object}
 */
const DateTypes = {
	DATE_ONLY : 'date_only', //no i18n
	TIME_ONLY : 'time_only', //no i18n
	DATE_TIME : 'date_and_time', //no i18n
	SPECIAL_DAY_DATE_ONLY : 'stringified_day_date_only', //no i18n
	SPECIAL_DAY_DATE_TIME : 'stringified_daydate_and_time', //no i18n
	CUSTOM_DATE_TIME : 'custom_date_time' //no i18n
}
Object.freeze(DateTypes);

/**
 * Convert ISO Date to portal date & time
 * @param {*} isoDate ISO date as string
 * @param {*} dateType Convertion type. Check global variable DateTypes for reference 
 * @returns Portal date & time
 */

function formatISODateString(isoDate, dateType) {
	if(!(moment(isoDate, moment.ISO_8601, true).isValid() && (isoDate.endsWith('Z') && isoDate.length == 24))) {
		return isoDate
	}
	let tz = getEffectiveTimeZone()
	let momentObject = moment.utc(isoDate).tz(tz)
	switch(dateType) {
		case DateTypes.DATE_ONLY : return momentObject.format(Utils.moment.dateformat)
		case DateTypes.DATE_TIME : return momentObject.format(Utils.moment.datetimeformat)
		case DateTypes.TIME_ONLY : return momentObject.format(Utils.moment.datetimeformat.replace(Utils.moment.dateformat+" ", ""))
		case DateTypes.SPECIAL_DAY_DATE_ONLY : return getSpecialDayString()
		case DateTypes.SPECIAL_DAY_DATE_TIME : return `${formatISODateString(isoDate, DateTypes.SPECIAL_DAY_DATE_ONLY)} @ ${formatISODateString(isoDate, DateTypes.TIME_ONLY)}`
		case DateTypes.CUSTOM_DATE_TIME : return momentObject.format("YYYY,MM,DD,HH,mm")//No I18N
	}
	return isoDate
	
	function getSpecialDayString() {
		if(moment().tz(tz).startOf('day').isSame(momentObject.startOf('day'))) {
			return getI18nValue('zp.general.today')//no i18n
		} else if(moment().tz(tz).subtract(1, 'days').startOf('day').isSame(momentObject.startOf('day'))) {//no i18n
			return getI18nValue('zp.displaymeet.yesterday')//no i18n
		} else if(moment().tz(tz).add(1, 'days').startOf('day').isSame(momentObject.startOf('day'))) {//no i18n
			return getI18nValue('zp.general.tomorrow')//no i18n
		}
		return formatISODateString(isoDate, DateTypes.DATE_ONLY)
	}
}

function getEffectiveTimeZone() {
	return Utils.isBrowserTimeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : Utils.moment.timezone
}

/**
 * Check the date is in weekend/holiday 
 * @param {*} date Date string
 * @returns {boolean} true if the date is in holiay. Otherwise false
 */
function isHoliday(date)
{
    if(Utils.weekendlist.indexOf(date.getDay()+1) !== -1 || Utils.holidaylist.indexOf(parseInt(formatDate(date, "yyyyMMdd"))) !== -1)
    {
        return true;
    }
    return false;
}

/**
 * Convert date into given format
 * @functionType function customDateFormat
 * @param {string} formatString date format
 * @returns {string} Returns formatted date
 */
Date.prototype.customDateFormat = function(formatString){
	var YYYY,YY,MMMM,MMM,MM,M,DDDD,DDD,DD,D;
	
	YY = ((YYYY=this.getFullYear())+"").slice(-2);
	MM = (M=this.getMonth()+1)<10?('0'+M):M;
	MMM = (MMMM=["January","February","March","April","May","June","July","August","September","October","November","December"][M-1]).substring(0,3);//No I18N
	DD = (D=this.getDate())<10?('0'+D):D;
	formatString = formatString.replace("YYYY",YYYY).replace("YY",YY).replace("MMMM",MMMM).replace("MMM",MMM).replace("MM",MM).replace("M",M).replace("DD",DD).replace("D",D);
	return formatString;
};

Object.assign(window, {DateTypes, formatISODateString, getEffectiveTimeZone, isHoliday});